import onIntersectionObserve from '@/helpers/on_intersection_observe';
import { isMobile } from '@/helpers/mobile_detect';
import track from '@/helpers/track';

let comparisonSliderApp = null;

$(document).on('turbolinks:before-cache', () => {
  if (comparisonSliderApp) {
    comparisonSliderApp.unmount();
    comparisonSliderApp = null;
  }
});

pageLoad('pages_root', async () => {
  if (!document.body.className.includes('v4')) { return; }

  onIntersectionObserve(
    document.querySelector('.slide_11 #franchise_comparison_slider'),
    async node => {
      const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
      const { default: Component } = await import('@/vue/franchise/comparison_slider');

      const $node = $(node);

      const comparisonSliderApp = createApp({
        setup: () => () => h(Component, {
          leftImageUrl: $node.data(`left_image_${isMobile() ? 'mobile' : 'desktop'}_url`),
          rightImageUrl: $node.data(`right_image_${isMobile() ? 'mobile' : 'desktop'}_url`)
        })
      });
      comparisonSliderApp.mount(node);
    }
  );
});
